import { gql } from "gql";

export const GET_COMPANY_DOCUMENT_TREE = gql(/* GraphQL */ `
  query GetCompanyDocumentTree($parentId: ID, $search: String) {
    getCompanyDocumentTree(parentId: $parentId, search: $search) {
      ...CompanyDocumentTreeNode
    }
  }
`);
